/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AcceptTesterInviteRouteImport } from './routes/accept-tester-invite'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as CompanyRouteImport } from './routes/_company'
import { Route as CompanyIndexRouteImport } from './routes/_company/index'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as CompanyEquipmentRouteImport } from './routes/_company/equipment'
import { Route as CompanyUtilitiesIndexRouteImport } from './routes/_company/utilities/index'
import { Route as CompanyTestKitsIndexRouteImport } from './routes/_company/test-kits/index'
import { Route as CompanySettingsIndexRouteImport } from './routes/_company/settings/index'
import { Route as CompanyMyWorkIndexRouteImport } from './routes/_company/my-work/index'
import { Route as CompanyMessagesIndexRouteImport } from './routes/_company/messages/index'
import { Route as CompanyHistoryIndexRouteImport } from './routes/_company/history/index'
import { Route as CompanyCredentialsIndexRouteImport } from './routes/_company/credentials/index'
import { Route as CompanyClaimIndexRouteImport } from './routes/_company/claim/index'
import { Route as CompanyChangeRequestsIndexRouteImport } from './routes/_company/change-requests/index'
import { Route as CompanyMyWorkNewInstallationRouteImport } from './routes/_company/my-work/new-installation'
import { Route as CompanyHistorySubmissionIdRouteImport } from './routes/_company/history/$submissionId'
import { Route as CompanyCredentialsCredentialIdRouteImport } from './routes/_company/credentials/$credentialId'
import { Route as CompanyChangeRequestsSetIdRouteImport } from './routes/_company/change-requests/$setId'
import { Route as CompanyMyWorkAssignmentIdIndexRouteImport } from './routes/_company/my-work/$assignmentId/index'
import { Route as CompanyCompanyUtilitiesIndexRouteImport } from './routes/_company/company/utilities/index'
import { Route as CompanyCompanySubmissionsIndexRouteImport } from './routes/_company/company/submissions/index'
import { Route as CompanyCompanyRosterIndexRouteImport } from './routes/_company/company/roster/index'
import { Route as CompanyCompanyProfileIndexRouteImport } from './routes/_company/company/profile/index'
import { Route as CompanyCompanyKitsIndexRouteImport } from './routes/_company/company/kits/index'
import { Route as CompanyCompanyFormsIndexRouteImport } from './routes/_company/company/forms/index'
import { Route as CompanyCompanyDispatchIndexRouteImport } from './routes/_company/company/dispatch/index'
import { Route as CompanyMyWorkReplaceInstallationIdRouteImport } from './routes/_company/my-work/replace.$installationId'
import { Route as CompanyMyWorkAssignmentIdSupplementRouteImport } from './routes/_company/my-work/$assignmentId/supplement'
import { Route as CompanyMyWorkAssignmentIdReplaceRouteImport } from './routes/_company/my-work/$assignmentId/replace'
import { Route as CompanyMyWorkAssignmentIdExecuteRouteImport } from './routes/_company/my-work/$assignmentId/execute'
import { Route as CompanyCompanySubmissionsSubmissionIdRouteImport } from './routes/_company/company/submissions/$submissionId'
import { Route as CompanyCompanyRosterMemberIdRouteImport } from './routes/_company/company/roster/$memberId'
import { Route as CompanyCompanyKitsNewRouteImport } from './routes/_company/company/kits/new'
import { Route as CompanyCompanyFormsNewRouteImport } from './routes/_company/company/forms/new'
import { Route as CompanyClaimFacilityFacilityIdRouteImport } from './routes/_company/claim/facility.$facilityId'
import { Route as CompanyMyWorkAccountsLinkIdIndexRouteImport } from './routes/_company/my-work/accounts.$linkId.index'
import { Route as CompanyCompanyKitsKitIdIndexRouteImport } from './routes/_company/company/kits/$kitId/index'
import { Route as CompanyCompanyFormsTemplateIdIndexRouteImport } from './routes/_company/company/forms/$templateId/index'
import { Route as CompanyCompanySubmissionsChangeRequestsSetIdRouteImport } from './routes/_company/company/submissions/change-requests.$setId'
import { Route as CompanyCompanyKitsKitIdEditRouteImport } from './routes/_company/company/kits/$kitId/edit'
import { Route as CompanyCompanyFormsSubmissionsSubmissionIdRouteImport } from './routes/_company/company/forms/submissions/$submissionId'
import { Route as CompanyCompanyFormsTemplateIdBuilderRouteImport } from './routes/_company/company/forms/$templateId/builder'
import { Route as CompanyMyWorkAccountsLinkIdPremisesFacilityIdRouteImport } from './routes/_company/my-work/accounts.$linkId.premises.$facilityId'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptTesterInviteRoute = AcceptTesterInviteRouteImport.update({
  id: '/accept-tester-invite',
  path: '/accept-tester-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyRoute = CompanyRouteImport.update({
  id: '/_company',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyIndexRoute = CompanyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CompanyRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyEquipmentRoute = CompanyEquipmentRouteImport.update({
  id: '/equipment',
  path: '/equipment',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyUtilitiesIndexRoute = CompanyUtilitiesIndexRouteImport.update({
  id: '/utilities/',
  path: '/utilities/',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyTestKitsIndexRoute = CompanyTestKitsIndexRouteImport.update({
  id: '/test-kits/',
  path: '/test-kits/',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanySettingsIndexRoute = CompanySettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyMyWorkIndexRoute = CompanyMyWorkIndexRouteImport.update({
  id: '/my-work/',
  path: '/my-work/',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyMessagesIndexRoute = CompanyMessagesIndexRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyHistoryIndexRoute = CompanyHistoryIndexRouteImport.update({
  id: '/history/',
  path: '/history/',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyCredentialsIndexRoute = CompanyCredentialsIndexRouteImport.update({
  id: '/credentials/',
  path: '/credentials/',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyClaimIndexRoute = CompanyClaimIndexRouteImport.update({
  id: '/claim/',
  path: '/claim/',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyChangeRequestsIndexRoute =
  CompanyChangeRequestsIndexRouteImport.update({
    id: '/change-requests/',
    path: '/change-requests/',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyMyWorkNewInstallationRoute =
  CompanyMyWorkNewInstallationRouteImport.update({
    id: '/my-work/new-installation',
    path: '/my-work/new-installation',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyHistorySubmissionIdRoute =
  CompanyHistorySubmissionIdRouteImport.update({
    id: '/history/$submissionId',
    path: '/history/$submissionId',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCredentialsCredentialIdRoute =
  CompanyCredentialsCredentialIdRouteImport.update({
    id: '/credentials/$credentialId',
    path: '/credentials/$credentialId',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyChangeRequestsSetIdRoute =
  CompanyChangeRequestsSetIdRouteImport.update({
    id: '/change-requests/$setId',
    path: '/change-requests/$setId',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyMyWorkAssignmentIdIndexRoute =
  CompanyMyWorkAssignmentIdIndexRouteImport.update({
    id: '/my-work/$assignmentId/',
    path: '/my-work/$assignmentId/',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanyUtilitiesIndexRoute =
  CompanyCompanyUtilitiesIndexRouteImport.update({
    id: '/company/utilities/',
    path: '/company/utilities/',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanySubmissionsIndexRoute =
  CompanyCompanySubmissionsIndexRouteImport.update({
    id: '/company/submissions/',
    path: '/company/submissions/',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanyRosterIndexRoute =
  CompanyCompanyRosterIndexRouteImport.update({
    id: '/company/roster/',
    path: '/company/roster/',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanyProfileIndexRoute =
  CompanyCompanyProfileIndexRouteImport.update({
    id: '/company/profile/',
    path: '/company/profile/',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanyKitsIndexRoute = CompanyCompanyKitsIndexRouteImport.update({
  id: '/company/kits/',
  path: '/company/kits/',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyCompanyFormsIndexRoute =
  CompanyCompanyFormsIndexRouteImport.update({
    id: '/company/forms/',
    path: '/company/forms/',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanyDispatchIndexRoute =
  CompanyCompanyDispatchIndexRouteImport.update({
    id: '/company/dispatch/',
    path: '/company/dispatch/',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyMyWorkReplaceInstallationIdRoute =
  CompanyMyWorkReplaceInstallationIdRouteImport.update({
    id: '/my-work/replace/$installationId',
    path: '/my-work/replace/$installationId',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyMyWorkAssignmentIdSupplementRoute =
  CompanyMyWorkAssignmentIdSupplementRouteImport.update({
    id: '/my-work/$assignmentId/supplement',
    path: '/my-work/$assignmentId/supplement',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyMyWorkAssignmentIdReplaceRoute =
  CompanyMyWorkAssignmentIdReplaceRouteImport.update({
    id: '/my-work/$assignmentId/replace',
    path: '/my-work/$assignmentId/replace',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyMyWorkAssignmentIdExecuteRoute =
  CompanyMyWorkAssignmentIdExecuteRouteImport.update({
    id: '/my-work/$assignmentId/execute',
    path: '/my-work/$assignmentId/execute',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanySubmissionsSubmissionIdRoute =
  CompanyCompanySubmissionsSubmissionIdRouteImport.update({
    id: '/company/submissions/$submissionId',
    path: '/company/submissions/$submissionId',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanyRosterMemberIdRoute =
  CompanyCompanyRosterMemberIdRouteImport.update({
    id: '/company/roster/$memberId',
    path: '/company/roster/$memberId',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanyKitsNewRoute = CompanyCompanyKitsNewRouteImport.update({
  id: '/company/kits/new',
  path: '/company/kits/new',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyCompanyFormsNewRoute = CompanyCompanyFormsNewRouteImport.update({
  id: '/company/forms/new',
  path: '/company/forms/new',
  getParentRoute: () => CompanyRoute,
} as any)
const CompanyClaimFacilityFacilityIdRoute =
  CompanyClaimFacilityFacilityIdRouteImport.update({
    id: '/claim/facility/$facilityId',
    path: '/claim/facility/$facilityId',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyMyWorkAccountsLinkIdIndexRoute =
  CompanyMyWorkAccountsLinkIdIndexRouteImport.update({
    id: '/my-work/accounts/$linkId/',
    path: '/my-work/accounts/$linkId/',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanyKitsKitIdIndexRoute =
  CompanyCompanyKitsKitIdIndexRouteImport.update({
    id: '/company/kits/$kitId/',
    path: '/company/kits/$kitId/',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanyFormsTemplateIdIndexRoute =
  CompanyCompanyFormsTemplateIdIndexRouteImport.update({
    id: '/company/forms/$templateId/',
    path: '/company/forms/$templateId/',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanySubmissionsChangeRequestsSetIdRoute =
  CompanyCompanySubmissionsChangeRequestsSetIdRouteImport.update({
    id: '/company/submissions/change-requests/$setId',
    path: '/company/submissions/change-requests/$setId',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanyKitsKitIdEditRoute =
  CompanyCompanyKitsKitIdEditRouteImport.update({
    id: '/company/kits/$kitId/edit',
    path: '/company/kits/$kitId/edit',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanyFormsSubmissionsSubmissionIdRoute =
  CompanyCompanyFormsSubmissionsSubmissionIdRouteImport.update({
    id: '/company/forms/submissions/$submissionId',
    path: '/company/forms/submissions/$submissionId',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyCompanyFormsTemplateIdBuilderRoute =
  CompanyCompanyFormsTemplateIdBuilderRouteImport.update({
    id: '/company/forms/$templateId/builder',
    path: '/company/forms/$templateId/builder',
    getParentRoute: () => CompanyRoute,
  } as any)
const CompanyMyWorkAccountsLinkIdPremisesFacilityIdRoute =
  CompanyMyWorkAccountsLinkIdPremisesFacilityIdRouteImport.update({
    id: '/my-work/accounts/$linkId/premises/$facilityId',
    path: '/my-work/accounts/$linkId/premises/$facilityId',
    getParentRoute: () => CompanyRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof CompanyIndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/accept-tester-invite': typeof AcceptTesterInviteRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/equipment': typeof CompanyEquipmentRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/change-requests/$setId': typeof CompanyChangeRequestsSetIdRoute
  '/credentials/$credentialId': typeof CompanyCredentialsCredentialIdRoute
  '/history/$submissionId': typeof CompanyHistorySubmissionIdRoute
  '/my-work/new-installation': typeof CompanyMyWorkNewInstallationRoute
  '/change-requests/': typeof CompanyChangeRequestsIndexRoute
  '/claim/': typeof CompanyClaimIndexRoute
  '/credentials/': typeof CompanyCredentialsIndexRoute
  '/history/': typeof CompanyHistoryIndexRoute
  '/messages/': typeof CompanyMessagesIndexRoute
  '/my-work/': typeof CompanyMyWorkIndexRoute
  '/settings/': typeof CompanySettingsIndexRoute
  '/test-kits/': typeof CompanyTestKitsIndexRoute
  '/utilities/': typeof CompanyUtilitiesIndexRoute
  '/claim/facility/$facilityId': typeof CompanyClaimFacilityFacilityIdRoute
  '/company/forms/new': typeof CompanyCompanyFormsNewRoute
  '/company/kits/new': typeof CompanyCompanyKitsNewRoute
  '/company/roster/$memberId': typeof CompanyCompanyRosterMemberIdRoute
  '/company/submissions/$submissionId': typeof CompanyCompanySubmissionsSubmissionIdRoute
  '/my-work/$assignmentId/execute': typeof CompanyMyWorkAssignmentIdExecuteRoute
  '/my-work/$assignmentId/replace': typeof CompanyMyWorkAssignmentIdReplaceRoute
  '/my-work/$assignmentId/supplement': typeof CompanyMyWorkAssignmentIdSupplementRoute
  '/my-work/replace/$installationId': typeof CompanyMyWorkReplaceInstallationIdRoute
  '/company/dispatch/': typeof CompanyCompanyDispatchIndexRoute
  '/company/forms/': typeof CompanyCompanyFormsIndexRoute
  '/company/kits/': typeof CompanyCompanyKitsIndexRoute
  '/company/profile/': typeof CompanyCompanyProfileIndexRoute
  '/company/roster/': typeof CompanyCompanyRosterIndexRoute
  '/company/submissions/': typeof CompanyCompanySubmissionsIndexRoute
  '/company/utilities/': typeof CompanyCompanyUtilitiesIndexRoute
  '/my-work/$assignmentId/': typeof CompanyMyWorkAssignmentIdIndexRoute
  '/company/forms/$templateId/builder': typeof CompanyCompanyFormsTemplateIdBuilderRoute
  '/company/forms/submissions/$submissionId': typeof CompanyCompanyFormsSubmissionsSubmissionIdRoute
  '/company/kits/$kitId/edit': typeof CompanyCompanyKitsKitIdEditRoute
  '/company/submissions/change-requests/$setId': typeof CompanyCompanySubmissionsChangeRequestsSetIdRoute
  '/company/forms/$templateId/': typeof CompanyCompanyFormsTemplateIdIndexRoute
  '/company/kits/$kitId/': typeof CompanyCompanyKitsKitIdIndexRoute
  '/my-work/accounts/$linkId/': typeof CompanyMyWorkAccountsLinkIdIndexRoute
  '/my-work/accounts/$linkId/premises/$facilityId': typeof CompanyMyWorkAccountsLinkIdPremisesFacilityIdRoute
}
export interface FileRoutesByTo {
  '/accept-invite': typeof AcceptInviteRoute
  '/accept-tester-invite': typeof AcceptTesterInviteRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/equipment': typeof CompanyEquipmentRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/': typeof CompanyIndexRoute
  '/change-requests/$setId': typeof CompanyChangeRequestsSetIdRoute
  '/credentials/$credentialId': typeof CompanyCredentialsCredentialIdRoute
  '/history/$submissionId': typeof CompanyHistorySubmissionIdRoute
  '/my-work/new-installation': typeof CompanyMyWorkNewInstallationRoute
  '/change-requests': typeof CompanyChangeRequestsIndexRoute
  '/claim': typeof CompanyClaimIndexRoute
  '/credentials': typeof CompanyCredentialsIndexRoute
  '/history': typeof CompanyHistoryIndexRoute
  '/messages': typeof CompanyMessagesIndexRoute
  '/my-work': typeof CompanyMyWorkIndexRoute
  '/settings': typeof CompanySettingsIndexRoute
  '/test-kits': typeof CompanyTestKitsIndexRoute
  '/utilities': typeof CompanyUtilitiesIndexRoute
  '/claim/facility/$facilityId': typeof CompanyClaimFacilityFacilityIdRoute
  '/company/forms/new': typeof CompanyCompanyFormsNewRoute
  '/company/kits/new': typeof CompanyCompanyKitsNewRoute
  '/company/roster/$memberId': typeof CompanyCompanyRosterMemberIdRoute
  '/company/submissions/$submissionId': typeof CompanyCompanySubmissionsSubmissionIdRoute
  '/my-work/$assignmentId/execute': typeof CompanyMyWorkAssignmentIdExecuteRoute
  '/my-work/$assignmentId/replace': typeof CompanyMyWorkAssignmentIdReplaceRoute
  '/my-work/$assignmentId/supplement': typeof CompanyMyWorkAssignmentIdSupplementRoute
  '/my-work/replace/$installationId': typeof CompanyMyWorkReplaceInstallationIdRoute
  '/company/dispatch': typeof CompanyCompanyDispatchIndexRoute
  '/company/forms': typeof CompanyCompanyFormsIndexRoute
  '/company/kits': typeof CompanyCompanyKitsIndexRoute
  '/company/profile': typeof CompanyCompanyProfileIndexRoute
  '/company/roster': typeof CompanyCompanyRosterIndexRoute
  '/company/submissions': typeof CompanyCompanySubmissionsIndexRoute
  '/company/utilities': typeof CompanyCompanyUtilitiesIndexRoute
  '/my-work/$assignmentId': typeof CompanyMyWorkAssignmentIdIndexRoute
  '/company/forms/$templateId/builder': typeof CompanyCompanyFormsTemplateIdBuilderRoute
  '/company/forms/submissions/$submissionId': typeof CompanyCompanyFormsSubmissionsSubmissionIdRoute
  '/company/kits/$kitId/edit': typeof CompanyCompanyKitsKitIdEditRoute
  '/company/submissions/change-requests/$setId': typeof CompanyCompanySubmissionsChangeRequestsSetIdRoute
  '/company/forms/$templateId': typeof CompanyCompanyFormsTemplateIdIndexRoute
  '/company/kits/$kitId': typeof CompanyCompanyKitsKitIdIndexRoute
  '/my-work/accounts/$linkId': typeof CompanyMyWorkAccountsLinkIdIndexRoute
  '/my-work/accounts/$linkId/premises/$facilityId': typeof CompanyMyWorkAccountsLinkIdPremisesFacilityIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_company': typeof CompanyRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/accept-tester-invite': typeof AcceptTesterInviteRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_company/equipment': typeof CompanyEquipmentRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/_company/': typeof CompanyIndexRoute
  '/_company/change-requests/$setId': typeof CompanyChangeRequestsSetIdRoute
  '/_company/credentials/$credentialId': typeof CompanyCredentialsCredentialIdRoute
  '/_company/history/$submissionId': typeof CompanyHistorySubmissionIdRoute
  '/_company/my-work/new-installation': typeof CompanyMyWorkNewInstallationRoute
  '/_company/change-requests/': typeof CompanyChangeRequestsIndexRoute
  '/_company/claim/': typeof CompanyClaimIndexRoute
  '/_company/credentials/': typeof CompanyCredentialsIndexRoute
  '/_company/history/': typeof CompanyHistoryIndexRoute
  '/_company/messages/': typeof CompanyMessagesIndexRoute
  '/_company/my-work/': typeof CompanyMyWorkIndexRoute
  '/_company/settings/': typeof CompanySettingsIndexRoute
  '/_company/test-kits/': typeof CompanyTestKitsIndexRoute
  '/_company/utilities/': typeof CompanyUtilitiesIndexRoute
  '/_company/claim/facility/$facilityId': typeof CompanyClaimFacilityFacilityIdRoute
  '/_company/company/forms/new': typeof CompanyCompanyFormsNewRoute
  '/_company/company/kits/new': typeof CompanyCompanyKitsNewRoute
  '/_company/company/roster/$memberId': typeof CompanyCompanyRosterMemberIdRoute
  '/_company/company/submissions/$submissionId': typeof CompanyCompanySubmissionsSubmissionIdRoute
  '/_company/my-work/$assignmentId/execute': typeof CompanyMyWorkAssignmentIdExecuteRoute
  '/_company/my-work/$assignmentId/replace': typeof CompanyMyWorkAssignmentIdReplaceRoute
  '/_company/my-work/$assignmentId/supplement': typeof CompanyMyWorkAssignmentIdSupplementRoute
  '/_company/my-work/replace/$installationId': typeof CompanyMyWorkReplaceInstallationIdRoute
  '/_company/company/dispatch/': typeof CompanyCompanyDispatchIndexRoute
  '/_company/company/forms/': typeof CompanyCompanyFormsIndexRoute
  '/_company/company/kits/': typeof CompanyCompanyKitsIndexRoute
  '/_company/company/profile/': typeof CompanyCompanyProfileIndexRoute
  '/_company/company/roster/': typeof CompanyCompanyRosterIndexRoute
  '/_company/company/submissions/': typeof CompanyCompanySubmissionsIndexRoute
  '/_company/company/utilities/': typeof CompanyCompanyUtilitiesIndexRoute
  '/_company/my-work/$assignmentId/': typeof CompanyMyWorkAssignmentIdIndexRoute
  '/_company/company/forms/$templateId/builder': typeof CompanyCompanyFormsTemplateIdBuilderRoute
  '/_company/company/forms/submissions/$submissionId': typeof CompanyCompanyFormsSubmissionsSubmissionIdRoute
  '/_company/company/kits/$kitId/edit': typeof CompanyCompanyKitsKitIdEditRoute
  '/_company/company/submissions/change-requests/$setId': typeof CompanyCompanySubmissionsChangeRequestsSetIdRoute
  '/_company/company/forms/$templateId/': typeof CompanyCompanyFormsTemplateIdIndexRoute
  '/_company/company/kits/$kitId/': typeof CompanyCompanyKitsKitIdIndexRoute
  '/_company/my-work/accounts/$linkId/': typeof CompanyMyWorkAccountsLinkIdIndexRoute
  '/_company/my-work/accounts/$linkId/premises/$facilityId': typeof CompanyMyWorkAccountsLinkIdPremisesFacilityIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/accept-tester-invite'
    | '/login'
    | '/signup'
    | '/verify-email'
    | '/equipment'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/change-requests/$setId'
    | '/credentials/$credentialId'
    | '/history/$submissionId'
    | '/my-work/new-installation'
    | '/change-requests/'
    | '/claim/'
    | '/credentials/'
    | '/history/'
    | '/messages/'
    | '/my-work/'
    | '/settings/'
    | '/test-kits/'
    | '/utilities/'
    | '/claim/facility/$facilityId'
    | '/company/forms/new'
    | '/company/kits/new'
    | '/company/roster/$memberId'
    | '/company/submissions/$submissionId'
    | '/my-work/$assignmentId/execute'
    | '/my-work/$assignmentId/replace'
    | '/my-work/$assignmentId/supplement'
    | '/my-work/replace/$installationId'
    | '/company/dispatch/'
    | '/company/forms/'
    | '/company/kits/'
    | '/company/profile/'
    | '/company/roster/'
    | '/company/submissions/'
    | '/company/utilities/'
    | '/my-work/$assignmentId/'
    | '/company/forms/$templateId/builder'
    | '/company/forms/submissions/$submissionId'
    | '/company/kits/$kitId/edit'
    | '/company/submissions/change-requests/$setId'
    | '/company/forms/$templateId/'
    | '/company/kits/$kitId/'
    | '/my-work/accounts/$linkId/'
    | '/my-work/accounts/$linkId/premises/$facilityId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/accept-invite'
    | '/accept-tester-invite'
    | '/login'
    | '/signup'
    | '/verify-email'
    | '/equipment'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/'
    | '/change-requests/$setId'
    | '/credentials/$credentialId'
    | '/history/$submissionId'
    | '/my-work/new-installation'
    | '/change-requests'
    | '/claim'
    | '/credentials'
    | '/history'
    | '/messages'
    | '/my-work'
    | '/settings'
    | '/test-kits'
    | '/utilities'
    | '/claim/facility/$facilityId'
    | '/company/forms/new'
    | '/company/kits/new'
    | '/company/roster/$memberId'
    | '/company/submissions/$submissionId'
    | '/my-work/$assignmentId/execute'
    | '/my-work/$assignmentId/replace'
    | '/my-work/$assignmentId/supplement'
    | '/my-work/replace/$installationId'
    | '/company/dispatch'
    | '/company/forms'
    | '/company/kits'
    | '/company/profile'
    | '/company/roster'
    | '/company/submissions'
    | '/company/utilities'
    | '/my-work/$assignmentId'
    | '/company/forms/$templateId/builder'
    | '/company/forms/submissions/$submissionId'
    | '/company/kits/$kitId/edit'
    | '/company/submissions/change-requests/$setId'
    | '/company/forms/$templateId'
    | '/company/kits/$kitId'
    | '/my-work/accounts/$linkId'
    | '/my-work/accounts/$linkId/premises/$facilityId'
  id:
    | '__root__'
    | '/_company'
    | '/accept-invite'
    | '/accept-tester-invite'
    | '/login'
    | '/signup'
    | '/verify-email'
    | '/_company/equipment'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/_company/'
    | '/_company/change-requests/$setId'
    | '/_company/credentials/$credentialId'
    | '/_company/history/$submissionId'
    | '/_company/my-work/new-installation'
    | '/_company/change-requests/'
    | '/_company/claim/'
    | '/_company/credentials/'
    | '/_company/history/'
    | '/_company/messages/'
    | '/_company/my-work/'
    | '/_company/settings/'
    | '/_company/test-kits/'
    | '/_company/utilities/'
    | '/_company/claim/facility/$facilityId'
    | '/_company/company/forms/new'
    | '/_company/company/kits/new'
    | '/_company/company/roster/$memberId'
    | '/_company/company/submissions/$submissionId'
    | '/_company/my-work/$assignmentId/execute'
    | '/_company/my-work/$assignmentId/replace'
    | '/_company/my-work/$assignmentId/supplement'
    | '/_company/my-work/replace/$installationId'
    | '/_company/company/dispatch/'
    | '/_company/company/forms/'
    | '/_company/company/kits/'
    | '/_company/company/profile/'
    | '/_company/company/roster/'
    | '/_company/company/submissions/'
    | '/_company/company/utilities/'
    | '/_company/my-work/$assignmentId/'
    | '/_company/company/forms/$templateId/builder'
    | '/_company/company/forms/submissions/$submissionId'
    | '/_company/company/kits/$kitId/edit'
    | '/_company/company/submissions/change-requests/$setId'
    | '/_company/company/forms/$templateId/'
    | '/_company/company/kits/$kitId/'
    | '/_company/my-work/accounts/$linkId/'
    | '/_company/my-work/accounts/$linkId/premises/$facilityId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  CompanyRoute: typeof CompanyRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  AcceptTesterInviteRoute: typeof AcceptTesterInviteRoute
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-tester-invite': {
      id: '/accept-tester-invite'
      path: '/accept-tester-invite'
      fullPath: '/accept-tester-invite'
      preLoaderRoute: typeof AcceptTesterInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_company': {
      id: '/_company'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof CompanyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_company/': {
      id: '/_company/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof CompanyIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_company/equipment': {
      id: '/_company/equipment'
      path: '/equipment'
      fullPath: '/equipment'
      preLoaderRoute: typeof CompanyEquipmentRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/utilities/': {
      id: '/_company/utilities/'
      path: '/utilities'
      fullPath: '/utilities/'
      preLoaderRoute: typeof CompanyUtilitiesIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/test-kits/': {
      id: '/_company/test-kits/'
      path: '/test-kits'
      fullPath: '/test-kits/'
      preLoaderRoute: typeof CompanyTestKitsIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/settings/': {
      id: '/_company/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof CompanySettingsIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/my-work/': {
      id: '/_company/my-work/'
      path: '/my-work'
      fullPath: '/my-work/'
      preLoaderRoute: typeof CompanyMyWorkIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/messages/': {
      id: '/_company/messages/'
      path: '/messages'
      fullPath: '/messages/'
      preLoaderRoute: typeof CompanyMessagesIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/history/': {
      id: '/_company/history/'
      path: '/history'
      fullPath: '/history/'
      preLoaderRoute: typeof CompanyHistoryIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/credentials/': {
      id: '/_company/credentials/'
      path: '/credentials'
      fullPath: '/credentials/'
      preLoaderRoute: typeof CompanyCredentialsIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/claim/': {
      id: '/_company/claim/'
      path: '/claim'
      fullPath: '/claim/'
      preLoaderRoute: typeof CompanyClaimIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/change-requests/': {
      id: '/_company/change-requests/'
      path: '/change-requests'
      fullPath: '/change-requests/'
      preLoaderRoute: typeof CompanyChangeRequestsIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/my-work/new-installation': {
      id: '/_company/my-work/new-installation'
      path: '/my-work/new-installation'
      fullPath: '/my-work/new-installation'
      preLoaderRoute: typeof CompanyMyWorkNewInstallationRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/history/$submissionId': {
      id: '/_company/history/$submissionId'
      path: '/history/$submissionId'
      fullPath: '/history/$submissionId'
      preLoaderRoute: typeof CompanyHistorySubmissionIdRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/credentials/$credentialId': {
      id: '/_company/credentials/$credentialId'
      path: '/credentials/$credentialId'
      fullPath: '/credentials/$credentialId'
      preLoaderRoute: typeof CompanyCredentialsCredentialIdRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/change-requests/$setId': {
      id: '/_company/change-requests/$setId'
      path: '/change-requests/$setId'
      fullPath: '/change-requests/$setId'
      preLoaderRoute: typeof CompanyChangeRequestsSetIdRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/my-work/$assignmentId/': {
      id: '/_company/my-work/$assignmentId/'
      path: '/my-work/$assignmentId'
      fullPath: '/my-work/$assignmentId/'
      preLoaderRoute: typeof CompanyMyWorkAssignmentIdIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/utilities/': {
      id: '/_company/company/utilities/'
      path: '/company/utilities'
      fullPath: '/company/utilities/'
      preLoaderRoute: typeof CompanyCompanyUtilitiesIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/submissions/': {
      id: '/_company/company/submissions/'
      path: '/company/submissions'
      fullPath: '/company/submissions/'
      preLoaderRoute: typeof CompanyCompanySubmissionsIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/roster/': {
      id: '/_company/company/roster/'
      path: '/company/roster'
      fullPath: '/company/roster/'
      preLoaderRoute: typeof CompanyCompanyRosterIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/profile/': {
      id: '/_company/company/profile/'
      path: '/company/profile'
      fullPath: '/company/profile/'
      preLoaderRoute: typeof CompanyCompanyProfileIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/kits/': {
      id: '/_company/company/kits/'
      path: '/company/kits'
      fullPath: '/company/kits/'
      preLoaderRoute: typeof CompanyCompanyKitsIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/forms/': {
      id: '/_company/company/forms/'
      path: '/company/forms'
      fullPath: '/company/forms/'
      preLoaderRoute: typeof CompanyCompanyFormsIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/dispatch/': {
      id: '/_company/company/dispatch/'
      path: '/company/dispatch'
      fullPath: '/company/dispatch/'
      preLoaderRoute: typeof CompanyCompanyDispatchIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/my-work/replace/$installationId': {
      id: '/_company/my-work/replace/$installationId'
      path: '/my-work/replace/$installationId'
      fullPath: '/my-work/replace/$installationId'
      preLoaderRoute: typeof CompanyMyWorkReplaceInstallationIdRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/my-work/$assignmentId/supplement': {
      id: '/_company/my-work/$assignmentId/supplement'
      path: '/my-work/$assignmentId/supplement'
      fullPath: '/my-work/$assignmentId/supplement'
      preLoaderRoute: typeof CompanyMyWorkAssignmentIdSupplementRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/my-work/$assignmentId/replace': {
      id: '/_company/my-work/$assignmentId/replace'
      path: '/my-work/$assignmentId/replace'
      fullPath: '/my-work/$assignmentId/replace'
      preLoaderRoute: typeof CompanyMyWorkAssignmentIdReplaceRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/my-work/$assignmentId/execute': {
      id: '/_company/my-work/$assignmentId/execute'
      path: '/my-work/$assignmentId/execute'
      fullPath: '/my-work/$assignmentId/execute'
      preLoaderRoute: typeof CompanyMyWorkAssignmentIdExecuteRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/submissions/$submissionId': {
      id: '/_company/company/submissions/$submissionId'
      path: '/company/submissions/$submissionId'
      fullPath: '/company/submissions/$submissionId'
      preLoaderRoute: typeof CompanyCompanySubmissionsSubmissionIdRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/roster/$memberId': {
      id: '/_company/company/roster/$memberId'
      path: '/company/roster/$memberId'
      fullPath: '/company/roster/$memberId'
      preLoaderRoute: typeof CompanyCompanyRosterMemberIdRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/kits/new': {
      id: '/_company/company/kits/new'
      path: '/company/kits/new'
      fullPath: '/company/kits/new'
      preLoaderRoute: typeof CompanyCompanyKitsNewRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/forms/new': {
      id: '/_company/company/forms/new'
      path: '/company/forms/new'
      fullPath: '/company/forms/new'
      preLoaderRoute: typeof CompanyCompanyFormsNewRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/claim/facility/$facilityId': {
      id: '/_company/claim/facility/$facilityId'
      path: '/claim/facility/$facilityId'
      fullPath: '/claim/facility/$facilityId'
      preLoaderRoute: typeof CompanyClaimFacilityFacilityIdRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/my-work/accounts/$linkId/': {
      id: '/_company/my-work/accounts/$linkId/'
      path: '/my-work/accounts/$linkId'
      fullPath: '/my-work/accounts/$linkId/'
      preLoaderRoute: typeof CompanyMyWorkAccountsLinkIdIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/kits/$kitId/': {
      id: '/_company/company/kits/$kitId/'
      path: '/company/kits/$kitId'
      fullPath: '/company/kits/$kitId/'
      preLoaderRoute: typeof CompanyCompanyKitsKitIdIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/forms/$templateId/': {
      id: '/_company/company/forms/$templateId/'
      path: '/company/forms/$templateId'
      fullPath: '/company/forms/$templateId/'
      preLoaderRoute: typeof CompanyCompanyFormsTemplateIdIndexRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/submissions/change-requests/$setId': {
      id: '/_company/company/submissions/change-requests/$setId'
      path: '/company/submissions/change-requests/$setId'
      fullPath: '/company/submissions/change-requests/$setId'
      preLoaderRoute: typeof CompanyCompanySubmissionsChangeRequestsSetIdRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/kits/$kitId/edit': {
      id: '/_company/company/kits/$kitId/edit'
      path: '/company/kits/$kitId/edit'
      fullPath: '/company/kits/$kitId/edit'
      preLoaderRoute: typeof CompanyCompanyKitsKitIdEditRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/forms/submissions/$submissionId': {
      id: '/_company/company/forms/submissions/$submissionId'
      path: '/company/forms/submissions/$submissionId'
      fullPath: '/company/forms/submissions/$submissionId'
      preLoaderRoute: typeof CompanyCompanyFormsSubmissionsSubmissionIdRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/company/forms/$templateId/builder': {
      id: '/_company/company/forms/$templateId/builder'
      path: '/company/forms/$templateId/builder'
      fullPath: '/company/forms/$templateId/builder'
      preLoaderRoute: typeof CompanyCompanyFormsTemplateIdBuilderRouteImport
      parentRoute: typeof CompanyRoute
    }
    '/_company/my-work/accounts/$linkId/premises/$facilityId': {
      id: '/_company/my-work/accounts/$linkId/premises/$facilityId'
      path: '/my-work/accounts/$linkId/premises/$facilityId'
      fullPath: '/my-work/accounts/$linkId/premises/$facilityId'
      preLoaderRoute: typeof CompanyMyWorkAccountsLinkIdPremisesFacilityIdRouteImport
      parentRoute: typeof CompanyRoute
    }
  }
}

interface CompanyRouteChildren {
  CompanyEquipmentRoute: typeof CompanyEquipmentRoute
  CompanyIndexRoute: typeof CompanyIndexRoute
  CompanyChangeRequestsSetIdRoute: typeof CompanyChangeRequestsSetIdRoute
  CompanyCredentialsCredentialIdRoute: typeof CompanyCredentialsCredentialIdRoute
  CompanyHistorySubmissionIdRoute: typeof CompanyHistorySubmissionIdRoute
  CompanyMyWorkNewInstallationRoute: typeof CompanyMyWorkNewInstallationRoute
  CompanyChangeRequestsIndexRoute: typeof CompanyChangeRequestsIndexRoute
  CompanyClaimIndexRoute: typeof CompanyClaimIndexRoute
  CompanyCredentialsIndexRoute: typeof CompanyCredentialsIndexRoute
  CompanyHistoryIndexRoute: typeof CompanyHistoryIndexRoute
  CompanyMessagesIndexRoute: typeof CompanyMessagesIndexRoute
  CompanyMyWorkIndexRoute: typeof CompanyMyWorkIndexRoute
  CompanySettingsIndexRoute: typeof CompanySettingsIndexRoute
  CompanyTestKitsIndexRoute: typeof CompanyTestKitsIndexRoute
  CompanyUtilitiesIndexRoute: typeof CompanyUtilitiesIndexRoute
  CompanyClaimFacilityFacilityIdRoute: typeof CompanyClaimFacilityFacilityIdRoute
  CompanyCompanyFormsNewRoute: typeof CompanyCompanyFormsNewRoute
  CompanyCompanyKitsNewRoute: typeof CompanyCompanyKitsNewRoute
  CompanyCompanyRosterMemberIdRoute: typeof CompanyCompanyRosterMemberIdRoute
  CompanyCompanySubmissionsSubmissionIdRoute: typeof CompanyCompanySubmissionsSubmissionIdRoute
  CompanyMyWorkAssignmentIdExecuteRoute: typeof CompanyMyWorkAssignmentIdExecuteRoute
  CompanyMyWorkAssignmentIdReplaceRoute: typeof CompanyMyWorkAssignmentIdReplaceRoute
  CompanyMyWorkAssignmentIdSupplementRoute: typeof CompanyMyWorkAssignmentIdSupplementRoute
  CompanyMyWorkReplaceInstallationIdRoute: typeof CompanyMyWorkReplaceInstallationIdRoute
  CompanyCompanyDispatchIndexRoute: typeof CompanyCompanyDispatchIndexRoute
  CompanyCompanyFormsIndexRoute: typeof CompanyCompanyFormsIndexRoute
  CompanyCompanyKitsIndexRoute: typeof CompanyCompanyKitsIndexRoute
  CompanyCompanyProfileIndexRoute: typeof CompanyCompanyProfileIndexRoute
  CompanyCompanyRosterIndexRoute: typeof CompanyCompanyRosterIndexRoute
  CompanyCompanySubmissionsIndexRoute: typeof CompanyCompanySubmissionsIndexRoute
  CompanyCompanyUtilitiesIndexRoute: typeof CompanyCompanyUtilitiesIndexRoute
  CompanyMyWorkAssignmentIdIndexRoute: typeof CompanyMyWorkAssignmentIdIndexRoute
  CompanyCompanyFormsTemplateIdBuilderRoute: typeof CompanyCompanyFormsTemplateIdBuilderRoute
  CompanyCompanyFormsSubmissionsSubmissionIdRoute: typeof CompanyCompanyFormsSubmissionsSubmissionIdRoute
  CompanyCompanyKitsKitIdEditRoute: typeof CompanyCompanyKitsKitIdEditRoute
  CompanyCompanySubmissionsChangeRequestsSetIdRoute: typeof CompanyCompanySubmissionsChangeRequestsSetIdRoute
  CompanyCompanyFormsTemplateIdIndexRoute: typeof CompanyCompanyFormsTemplateIdIndexRoute
  CompanyCompanyKitsKitIdIndexRoute: typeof CompanyCompanyKitsKitIdIndexRoute
  CompanyMyWorkAccountsLinkIdIndexRoute: typeof CompanyMyWorkAccountsLinkIdIndexRoute
  CompanyMyWorkAccountsLinkIdPremisesFacilityIdRoute: typeof CompanyMyWorkAccountsLinkIdPremisesFacilityIdRoute
}

const CompanyRouteChildren: CompanyRouteChildren = {
  CompanyEquipmentRoute: CompanyEquipmentRoute,
  CompanyIndexRoute: CompanyIndexRoute,
  CompanyChangeRequestsSetIdRoute: CompanyChangeRequestsSetIdRoute,
  CompanyCredentialsCredentialIdRoute: CompanyCredentialsCredentialIdRoute,
  CompanyHistorySubmissionIdRoute: CompanyHistorySubmissionIdRoute,
  CompanyMyWorkNewInstallationRoute: CompanyMyWorkNewInstallationRoute,
  CompanyChangeRequestsIndexRoute: CompanyChangeRequestsIndexRoute,
  CompanyClaimIndexRoute: CompanyClaimIndexRoute,
  CompanyCredentialsIndexRoute: CompanyCredentialsIndexRoute,
  CompanyHistoryIndexRoute: CompanyHistoryIndexRoute,
  CompanyMessagesIndexRoute: CompanyMessagesIndexRoute,
  CompanyMyWorkIndexRoute: CompanyMyWorkIndexRoute,
  CompanySettingsIndexRoute: CompanySettingsIndexRoute,
  CompanyTestKitsIndexRoute: CompanyTestKitsIndexRoute,
  CompanyUtilitiesIndexRoute: CompanyUtilitiesIndexRoute,
  CompanyClaimFacilityFacilityIdRoute: CompanyClaimFacilityFacilityIdRoute,
  CompanyCompanyFormsNewRoute: CompanyCompanyFormsNewRoute,
  CompanyCompanyKitsNewRoute: CompanyCompanyKitsNewRoute,
  CompanyCompanyRosterMemberIdRoute: CompanyCompanyRosterMemberIdRoute,
  CompanyCompanySubmissionsSubmissionIdRoute:
    CompanyCompanySubmissionsSubmissionIdRoute,
  CompanyMyWorkAssignmentIdExecuteRoute: CompanyMyWorkAssignmentIdExecuteRoute,
  CompanyMyWorkAssignmentIdReplaceRoute: CompanyMyWorkAssignmentIdReplaceRoute,
  CompanyMyWorkAssignmentIdSupplementRoute:
    CompanyMyWorkAssignmentIdSupplementRoute,
  CompanyMyWorkReplaceInstallationIdRoute:
    CompanyMyWorkReplaceInstallationIdRoute,
  CompanyCompanyDispatchIndexRoute: CompanyCompanyDispatchIndexRoute,
  CompanyCompanyFormsIndexRoute: CompanyCompanyFormsIndexRoute,
  CompanyCompanyKitsIndexRoute: CompanyCompanyKitsIndexRoute,
  CompanyCompanyProfileIndexRoute: CompanyCompanyProfileIndexRoute,
  CompanyCompanyRosterIndexRoute: CompanyCompanyRosterIndexRoute,
  CompanyCompanySubmissionsIndexRoute: CompanyCompanySubmissionsIndexRoute,
  CompanyCompanyUtilitiesIndexRoute: CompanyCompanyUtilitiesIndexRoute,
  CompanyMyWorkAssignmentIdIndexRoute: CompanyMyWorkAssignmentIdIndexRoute,
  CompanyCompanyFormsTemplateIdBuilderRoute:
    CompanyCompanyFormsTemplateIdBuilderRoute,
  CompanyCompanyFormsSubmissionsSubmissionIdRoute:
    CompanyCompanyFormsSubmissionsSubmissionIdRoute,
  CompanyCompanyKitsKitIdEditRoute: CompanyCompanyKitsKitIdEditRoute,
  CompanyCompanySubmissionsChangeRequestsSetIdRoute:
    CompanyCompanySubmissionsChangeRequestsSetIdRoute,
  CompanyCompanyFormsTemplateIdIndexRoute:
    CompanyCompanyFormsTemplateIdIndexRoute,
  CompanyCompanyKitsKitIdIndexRoute: CompanyCompanyKitsKitIdIndexRoute,
  CompanyMyWorkAccountsLinkIdIndexRoute: CompanyMyWorkAccountsLinkIdIndexRoute,
  CompanyMyWorkAccountsLinkIdPremisesFacilityIdRoute:
    CompanyMyWorkAccountsLinkIdPremisesFacilityIdRoute,
}

const CompanyRouteWithChildren =
  CompanyRoute._addFileChildren(CompanyRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  CompanyRoute: CompanyRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  AcceptTesterInviteRoute: AcceptTesterInviteRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
